module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Justice-League.6107a75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Justice-League.jpg
// module id = yAVc
// module chunks = 0